var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadAndroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_192",
    "data-name": "Group 192",
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M130,40H5a5.015,5.015,0,0,1-5-5V5A5.015,5.015,0,0,1,5,0H130a5.015,5.015,0,0,1,5,5V35a5.015,5.015,0,0,1-5,5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M44.453,9.841h2.069v2.933a6.068,6.068,0,0,1-.98.234,7.409,7.409,0,0,1-1.123.076,3.05,3.05,0,0,1-1.567-.373,2.4,2.4,0,0,1-.968-1.064,3.757,3.757,0,0,1-.331-1.639,3.387,3.387,0,0,1,.369-1.625,2.6,2.6,0,0,1,1.06-1.068,3.4,3.4,0,0,1,1.671-.382,4.663,4.663,0,0,1,.951.093,4.146,4.146,0,0,1,.834.259l-.285.654a4.472,4.472,0,0,0-.716-.244,3.407,3.407,0,0,0-.825-.1,2.42,2.42,0,0,0-1.223.293,1.93,1.93,0,0,0-.78.834,2.874,2.874,0,0,0-.268,1.286,3.247,3.247,0,0,0,.23,1.262,1.79,1.79,0,0,0,.725.854,2.442,2.442,0,0,0,1.3.306,4.549,4.549,0,0,0,.67-.042,4.759,4.759,0,0,0,.5-.1V10.511H44.453Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M44.453,9.841h2.069v2.933a6.068,6.068,0,0,1-.98.234,7.409,7.409,0,0,1-1.123.076,3.05,3.05,0,0,1-1.567-.373,2.4,2.4,0,0,1-.968-1.064,3.757,3.757,0,0,1-.331-1.639,3.387,3.387,0,0,1,.369-1.625,2.6,2.6,0,0,1,1.06-1.068,3.4,3.4,0,0,1,1.671-.382,4.663,4.663,0,0,1,.951.093,4.146,4.146,0,0,1,.834.259l-.285.654a4.472,4.472,0,0,0-.716-.244,3.407,3.407,0,0,0-.825-.1,2.42,2.42,0,0,0-1.223.293,1.93,1.93,0,0,0-.78.834,2.874,2.874,0,0,0-.268,1.286,3.247,3.247,0,0,0,.23,1.262,1.79,1.79,0,0,0,.725.854,2.442,2.442,0,0,0,1.3.306,4.549,4.549,0,0,0,.67-.042,4.759,4.759,0,0,0,.5-.1V10.511H44.453Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M51.466,13H48.122V7.017h3.344v.662H48.877V9.547h2.439V10.2H48.877v2.137h2.589Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M51.466,13H48.122V7.017h3.344v.662H48.877V9.547h2.439V10.2H48.877v2.137h2.589Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M54.843,13h-.755V7.679H52.22V7.017H56.7v.662h-1.86Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M54.843,13h-.755V7.679H52.22V7.017H56.7v.662h-1.86Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M61.807,13H59.645v-.436l.7-.159V7.62l-.7-.168V7.017h2.162v.435l-.7.168v4.785l.7.159Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M61.807,13H59.645v-.436l.7-.159V7.62l-.7-.168V7.017h2.162v.435l-.7.168v4.785l.7.159Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M65.025,13H64.27V7.679H62.4V7.017h4.483v.662h-1.86Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M65.025,13H64.27V7.679H62.4V7.017h4.483v.662h-1.86Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M75.526,10a4.242,4.242,0,0,1-.176,1.261,2.744,2.744,0,0,1-.524.976,2.265,2.265,0,0,1-.863.629,3.05,3.05,0,0,1-1.194.218,3.1,3.1,0,0,1-1.224-.222,2.278,2.278,0,0,1-.862-.629,2.623,2.623,0,0,1-.512-.976A4.5,4.5,0,0,1,70,9.992a3.975,3.975,0,0,1,.3-1.609,2.35,2.35,0,0,1,.918-1.073,2.882,2.882,0,0,1,1.555-.385,2.8,2.8,0,0,1,1.507.381,2.4,2.4,0,0,1,.927,1.072A3.9,3.9,0,0,1,75.526,10M70.8,10a3.611,3.611,0,0,0,.209,1.3,1.718,1.718,0,0,0,.649.838,1.959,1.959,0,0,0,1.111.293,1.929,1.929,0,0,0,1.11-.293,1.735,1.735,0,0,0,.642-.838A3.633,3.633,0,0,0,74.73,10a2.953,2.953,0,0,0-.469-1.772,1.716,1.716,0,0,0-1.483-.642,2,2,0,0,0-1.12.29,1.69,1.69,0,0,0-.649.829A3.577,3.577,0,0,0,70.8,10",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M75.526,10a4.242,4.242,0,0,1-.176,1.261,2.744,2.744,0,0,1-.524.976,2.265,2.265,0,0,1-.863.629,3.05,3.05,0,0,1-1.194.218,3.1,3.1,0,0,1-1.224-.222,2.278,2.278,0,0,1-.862-.629,2.623,2.623,0,0,1-.512-.976A4.5,4.5,0,0,1,70,9.992a3.975,3.975,0,0,1,.3-1.609,2.35,2.35,0,0,1,.918-1.073,2.882,2.882,0,0,1,1.555-.385,2.8,2.8,0,0,1,1.507.381,2.4,2.4,0,0,1,.927,1.072A3.9,3.9,0,0,1,75.526,10ZM70.8,10a3.611,3.611,0,0,0,.209,1.3,1.718,1.718,0,0,0,.649.838,1.959,1.959,0,0,0,1.111.293,1.929,1.929,0,0,0,1.11-.293,1.735,1.735,0,0,0,.642-.838A3.633,3.633,0,0,0,74.73,10a2.953,2.953,0,0,0-.469-1.772,1.716,1.716,0,0,0-1.483-.642,2,2,0,0,0-1.12.29,1.69,1.69,0,0,0-.649.829A3.577,3.577,0,0,0,70.8,10Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M81.76,13h-.88l-3.2-4.969h-.033c.01.128.02.281.029.456s.017.364.025.562.013.4.013.607V13h-.7V7.017h.872l3.192,4.952h.034q-.007-.133-.021-.4c-.008-.179-.017-.374-.025-.587s-.013-.407-.013-.586V7.017h.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M81.76,13h-.88l-3.2-4.969h-.033c.01.128.02.281.029.456s.017.364.025.562.013.4.013.607V13h-.7V7.017h.872l3.192,4.952h.034q-.007-.133-.021-.4c-.008-.179-.017-.374-.025-.587s-.013-.407-.013-.586V7.017h.7Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M68.136,21.752A4.253,4.253,0,1,0,72.4,26a4.192,4.192,0,0,0-4.269-4.253m0,6.83A2.584,2.584,0,1,1,70.536,26a2.46,2.46,0,0,1-2.4,2.577m-9.314-6.83A4.253,4.253,0,1,0,63.092,26a4.192,4.192,0,0,0-4.27-4.253m0,6.83A2.584,2.584,0,1,1,61.223,26a2.46,2.46,0,0,1-2.4,2.577M47.744,23.057v1.8h4.317a3.765,3.765,0,0,1-.982,2.271,4.42,4.42,0,0,1-3.335,1.321,4.8,4.8,0,0,1,0-9.6A4.6,4.6,0,0,1,51,20.14l1.273-1.272a6.3,6.3,0,0,0-4.527-1.821,6.606,6.606,0,1,0,0,13.211,6.04,6.04,0,0,0,4.607-1.853,5.962,5.962,0,0,0,1.563-4.221,5.829,5.829,0,0,0-.1-1.127Zm45.308,1.4a3.954,3.954,0,0,0-3.641-2.706A4.041,4.041,0,0,0,85.4,26a4.162,4.162,0,0,0,4.22,4.253,4.232,4.232,0,0,0,3.545-1.885l-1.45-.967a2.43,2.43,0,0,1-2.095,1.176,2.164,2.164,0,0,1-2.062-1.288l5.687-2.353Zm-5.8,1.418A2.333,2.333,0,0,1,89.475,23.4a1.646,1.646,0,0,1,1.579.9ZM82.628,30H84.5V17.5H82.628Zm-3.061-7.3H79.5a2.948,2.948,0,0,0-2.239-.95,4.257,4.257,0,0,0,0,8.506,2.9,2.9,0,0,0,2.239-.967h.064V29.9c0,1.628-.869,2.5-2.271,2.5a2.354,2.354,0,0,1-2.143-1.515l-1.627.677a4.053,4.053,0,0,0,3.77,2.513c2.191,0,4.044-1.289,4.044-4.43V22.009H79.567Zm-2.142,5.88a2.587,2.587,0,0,1,0-5.155A2.4,2.4,0,0,1,79.7,26.021a2.376,2.376,0,0,1-2.271,2.561M101.806,17.5H97.335V30H99.2V25.264h2.606a3.888,3.888,0,1,0,0-7.765m.048,6.025H99.2V19.239h2.654a2.143,2.143,0,1,1,0,4.285m11.532-1.8a3.505,3.505,0,0,0-3.33,1.913l1.657.692a1.768,1.768,0,0,1,1.705-.917,1.8,1.8,0,0,1,1.962,1.609v.128a4.128,4.128,0,0,0-1.946-.482c-1.785,0-3.6.981-3.6,2.814a2.889,2.889,0,0,0,3.1,2.751,2.633,2.633,0,0,0,2.381-1.223h.064v.965h1.8V25.186c0-2.219-1.656-3.457-3.795-3.457m-.225,6.851c-.612,0-1.464-.306-1.464-1.062,0-.965,1.061-1.334,1.978-1.334a3.319,3.319,0,0,1,1.7.418,2.262,2.262,0,0,1-2.219,1.978M123.743,22l-2.139,5.42h-.064L119.32,22h-2.01l3.329,7.575-1.9,4.214h1.946L125.818,22Zm-16.807,8H108.8V17.5h-1.866Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M20.717,19.424,10.07,30.724l0,.007a2.878,2.878,0,0,0,4.236,1.734l.034-.02L26.326,25.53Z",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M31.488,17.5l-.01-.007-5.174-3-5.829,5.187,5.85,5.848,5.146-2.969a2.878,2.878,0,0,0,.017-5.06",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M10.07,9.277a2.823,2.823,0,0,0-.1.74V29.985a2.769,2.769,0,0,0,.1.739L21.083,19.713Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M20.8,20l5.51-5.509-11.97-6.94a2.881,2.881,0,0,0-4.265,1.722v0Z",
    fill: "#34a853"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAndroid);
export default __webpack_public_path__ + "static/media/downloadAndroid.70be819d9fb0324fa5aa57c38b2c2b4d.svg";
export { ForwardRef as ReactComponent };